import {
  SystemUrlAllowlist,
  ToolsContainsStringTester,
  ToolsNaturalDateTester,
  ToolsRegexReplaceTester,
  ToolsRegexTester
} from "@graylog/server-api";
import fetch from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
export const testNaturalDate = (keyword, userTimezone) => {
  const promise = ToolsNaturalDateTester.naturalDateTester(keyword, userTimezone);
  promise.catch((errorThrown) => {
    if (errorThrown.additional.status !== 422) {
      UserNotification.error(
        `Loading keyword preview failed with status: ${errorThrown}`,
        "Could not load keyword preview"
      );
    }
  });
  return promise;
};
export const testGrok = (pattern, namedCapturesOnly, string) => {
  const { url } = ApiRoutes.ToolsApiController.grokTest();
  const promise = fetch("POST", qualifyUrl(url), {
    pattern,
    string,
    named_captures_only: namedCapturesOnly
  });
  promise.catch((errorThrown) => {
    UserNotification.error(
      `Details: ${errorThrown}`,
      "We were not able to run the grok extraction. Please check your parameters."
    );
  });
  return promise;
};
export const testJSON = (flatten, listSeparator, keySeparator, kvSeparator, replaceKeyWhitespace, keyWhitespaceReplacement, keyPrefix, string) => {
  const { url } = ApiRoutes.ToolsApiController.jsonTest();
  const payload = {
    flatten,
    list_separator: listSeparator,
    key_separator: keySeparator,
    kv_separator: kvSeparator,
    replace_key_whitespace: replaceKeyWhitespace,
    key_whitespace_replacement: keyWhitespaceReplacement,
    key_prefix: keyPrefix,
    string
  };
  const promise = fetch("POST", qualifyUrl(url), payload);
  promise.catch((errorThrown) => {
    UserNotification.error(
      `Details: ${errorThrown}`,
      "We were not able to run the JSON extraction. Please check your parameters."
    );
  });
  return promise;
};
export const testRegexValidity = (regex) => {
  const promise = ToolsRegexTester.validateRegex(regex);
  promise.catch((errorThrown) => {
    UserNotification.error(
      `Details: ${errorThrown}`,
      "Could not validate regular expression. Make sure that it is valid."
    );
  });
  return promise;
};
export const urlAllowListCheck = (urlToCheck) => {
  const promise = SystemUrlAllowlist.check({
    url: urlToCheck
  });
  promise.catch((errorThrown) => {
    UserNotification.error(`Details: ${errorThrown}`, "Could not verify if the url is in the allowlist.");
  });
  return promise;
};
export const urlAllowListGenerateRegex = (urlTemplate, placeholder) => {
  const { url } = ApiRoutes.ToolsApiController.urlAllowlistGenerateRegex();
  const promise = fetch("POST", qualifyUrl(url), {
    url_template: urlTemplate,
    placeholder
  });
  promise.catch((errorThrown) => {
    UserNotification.error(`Details: ${errorThrown}`, "Could not generate regex.");
  });
  return promise;
};
export const testRegex = (regex, string) => {
  const promise = ToolsRegexTester.testRegex({
    regex,
    string
  });
  promise.catch((errorThrown) => {
    UserNotification.error(`Details: ${errorThrown}`, "Could not try regular expression. Make sure that it is valid.");
  });
  return promise;
};
export const testRegexReplace = (regex, replacement, replaceAll, string) => {
  const payload = {
    regex,
    replacement,
    replace_all: replaceAll,
    string
  };
  const promise = ToolsRegexReplaceTester.testRegex(payload);
  promise.catch((errorThrown) => {
    UserNotification.error(`Details: ${errorThrown}`, "Could not try regular expression. Make sure that it is valid.");
  });
  return promise;
};
export const testSplitAndIndex = (splitBy, index, string) => {
  const { url } = ApiRoutes.ToolsApiController.splitAndIndexTest();
  const payload = {
    split_by: splitBy,
    index,
    string
  };
  const promise = fetch("POST", qualifyUrl(url), payload);
  promise.catch((errorThrown) => {
    UserNotification.error(
      `Details: ${errorThrown}`,
      "We were not able to run the split and index extraction. Please check your parameters."
    );
  });
  return promise;
};
export const testSubstring = (beginIndex, endIndex, string) => {
  const { url } = ApiRoutes.ToolsApiController.substringTest();
  const payload = {
    start: beginIndex,
    end: endIndex,
    string
  };
  const promise = fetch("POST", qualifyUrl(url), payload);
  promise.catch((errorThrown) => {
    UserNotification.error(
      `Details: ${errorThrown}`,
      "We were not able to run the substring extraction. Please check index boundaries."
    );
  });
  return promise;
};
export const testContainsString = (searchString, string) => {
  const promise = ToolsContainsStringTester.testContainsString({
    search_string: searchString,
    string
  });
  promise.catch((errorThrown) => {
    UserNotification.error(`Details: ${errorThrown}`, "Could not check if field contains the string");
  });
  return promise;
};
export const testLookupTable = (lookupTableName, string) => {
  const { url } = ApiRoutes.ToolsApiController.lookupTableTest();
  const promise = fetch("POST", qualifyUrl(url), {
    lookup_table_name: lookupTableName,
    string
  });
  promise.catch((errorThrown) => {
    UserNotification.error(`Details: ${errorThrown}`, "Could not check if lookup table translates the string");
  });
  return promise;
};
